import tetherfiLogo from '../../assets/icons/tetherfi-logo.svg';
import loadingGraphic from '../../assets/icons/loading-graphic.svg';
import './index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { ILoadingPageProps } from '../../interfaces/loading';

const packageInfo = require('../../../package.json');

export const LoadingPage = (props: ILoadingPageProps) => {
    return <div className='loading-page-container'>
        <div className='loading-page-logo-container'>
            <img src={tetherfiLogo} alt='' />
        </div>
        <div className='loading-page-loading-indicator-container'>
            <FontAwesomeIcon icon={faSpinnerThird} size="6x" color='#FACD00' spin />
        </div>
        <div className='loading-page-loading-text-container'>
            <span>{props.message ?? "Loading"}</span>
        </div>
        <div className='loading-page-loading-graphic-container'>
            <img src={loadingGraphic} alt='' />
        </div>
        <div className='version-container'>
            <span>{packageInfo.version}</span>
        </div>
    </div>
}